import React from "react";
import pic5 from "../images/Most-Beautiful-House-in-the-World.jpg";
import { useState, useEffect } from "react";
import Axios from "../config/Axios"
import CircularProgress from '@mui/material/CircularProgress';
import Grid from '@mui/material/Grid';
import Typography from "@mui/material/Typography";

export const AvailableHouse = () => {
    const [houses, setHouses] = useState([]);
    const [loading, setLoading] = useState(false);

    const getHouses = async () => {
        setLoading(true);
        const config = {
            headers: {
                "Content-type": "application/json",
            },
        };

        const result = await Axios.get("/house/availableHouses", config);
        console.log(result.data.houses);
        let temp = result.data.houses;
        for (let i = 0; i < temp.length; i++) {
            console.log(temp[i])
            const email = await Axios.post("/auth/getEmailId", { id: temp[i].userId }, config);
            console.log(email.data.emailId)
            temp[i]['emailId'] = (email.data.emailId)
        }
        setLoading(false);
        setHouses(temp);
    }

    useEffect(() => {
        getHouses();
    }, []);



    return (
        <div>
            <div>
                <h1 style={{ margin: "auto", textAlign: "center", marginTop: "1rem" }}>Availabe houses for rent </h1>
                <Typography
                    component="p"
                    variant="p"
                    align="center"
                    fontSize={"13px"}
                    fontWeight={"bold"}
                    sx={{ marginBottom: "10px" }}
                >
                    <span className="predictiHeading">*Might take some time (app. 2mins) because hosted on a free server...</span>
                </Typography>
                <div>
                    {
                        loading === true ? <div className=""><Grid
                            container
                            spacing={0}
                            direction="column"
                            alignItems="center"
                            justifyContent="center"
                            sx={{ minHeight: '80vh' }}
                        >
                            <Grid item xs={3}>
                                <CircularProgress />

                            </Grid>
                        </Grid> </div> : <div class="cards">

                            {
                                houses.map((item, index) => {
                                    return (<div class="card">
                                        <div class="card__image-holder">
                                            <img class="card__image" src={pic5} alt="beach" />
                                        </div>
                                        <div class="card-title">
                                            <h2>Home {index + 1}</h2>
                                        </div>
                                        <div>
                                            <div class="card-description">
                                                Area: {item.area}
                                            </div>
                                            <div class="card-description">
                                                Location: {item.location}
                                            </div>
                                            <div class="card-description">
                                                City: {item.city}
                                            </div>
                                            <div class="card-description">
                                                Contact Email: {item.emailId}
                                            </div>
                                        </div>
                                    </div>
                                    )
                                })
                            }


                        </div>
                    }

                </div>
            </div>
        </div>
    )
}